module.exports = __webpack_public_path__ + "assets/adf42fa95b23bea787a5519745d93a29.png";